/**
 * Single dynamic entry for axios so Webpack emits one shared async chunk
 * (avoids Lighthouse “duplicate javascript” from multiple import("axios") sites).
 */

import { attachBackendAxiosAuth, installBackendAxiosAuth } from "./installBackendAxiosAuth";

let axiosModulePromise;

export function loadAxios() {
  if (!axiosModulePromise) {
    axiosModulePromise = import("axios").then((m) => {
      installBackendAxiosAuth();
      attachBackendAxiosAuth(m.default);
      return m.default;
    });
  }
  return axiosModulePromise;
}
